import { useEffect, useState } from "react";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";

import * as Theme from "../../../../app/Theme";

import * as gbtu from "../../../GB/GBTableUtil";
import * as piasu from "../../NonComponents/PIAppStateUtil";
import * as pisc from "../../NonComponents/PIServerConst";
import * as gbtc from "../../../GB/GBTableConst";
import * as pitu from "../../NonComponents/PITableUtil";
import * as piu from "../../NonComponents/PIUtil";

import { generateTypes, repeat } from "../../../../utilities";
import SuperTableShim from "../../../common/SuperTableShim";

import { getProjDefaultsAsync } from "../../../../api/server_calls";
import { combinePriorPops, genAndKeyPopsCombinedPops } from "../../NonComponents/PIPriorPopUtil";
import { onCalculateAsync } from "../../NonComponents/PICalc";

const priorPopRow = 0;
const initTotalRow = 1;
const persCostCatInit = 2;
const labCostCatInit = 3;
const otherRecCostCatInit = 4;
const capCostsCostCatInit = 5;
const contTotalRow = 6;
const persCostCatCont = 7;
const labCostCatCont = 8;
const otherRecCostCatCont = 9;
const capCostsCostCatCont = 10;
const numRows = capCostsCostCatCont + 1;

const costCatCol = 0;

const PIDefCostsPerVisitRefTable = (props) => {
  const { modVarObjList } = props;

  const [loading, setLoading] = useState(true);
  const [defaultCosts, setDefaultCosts] = useState([]);
  const [defaultEligibility, setDefaultEligibility] = useState([]);
  const [defaultPops, setDefaultPops] = useState([]);

  const selectedMethodID = piasu.getModVarValue(modVarObjList, pisc.selectedMethodMVTag);
  const pseMode = piasu.isPSEMode(modVarObjList);

  useEffect(() => {
    const fetchDefaults = async () => {
      try {
        props.onCalculatingChange(true);
        const countryCode = piasu.getModVarValue(modVarObjList, pisc.countryISOMVTag);
        const { modvars: defaults } = await getProjDefaultsAsync({ countryCode, pse: pseMode });
        const defModVars = await onCalculateAsync(defaults, "", props.onDialogChange);

        let priorPops = piasu.getModVarValue(defModVars, pisc.priorPopsMVTag);
        let eligibility = piasu.getModVarValue(defModVars, pisc.priorPopMethodEligMVTag);
        let costCatLite = piasu.getModVarValue(defModVars, pisc.costCategoriesLiteMVTag);
        if (pseMode) {
          const combined = combinePriorPops(defModVars, genAndKeyPopsCombinedPops, [
            pisc.priorPopMethodEligMVTag,
            pisc.costCategoriesLiteMVTag,
          ]);
          priorPops = combined[pisc.priorPopsMVTag];
          eligibility = combined[pisc.priorPopMethodEligMVTag];
          costCatLite = combined[pisc.costCategoriesLiteMVTag];
        }

        setDefaultCosts(costCatLite);
        setDefaultEligibility(eligibility);
        setDefaultPops(priorPops);

        setLoading(false);
      } catch (err) {
        console.error(err);
      } finally {
        props.onCalculatingChange(false);
      }
    };

    fetchDefaults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <p>Loading...</p>;

  const getPackTable = () => {
    let packTable = gbtu.getNewPackTable();
    const numCols = defaultPops.length + 1;

    packTable = gbtu.resizePackTable(packTable, numRows, numCols);

    gbtu.setValue(packTable, priorPopRow, costCatCol, RS(SC.GB_stCostCategory));

    gbtu.setValue(packTable, initTotalRow, costCatCol, RS(SC.GB_stInitiationVisit));
    gbtu.setFontStyle(packTable, initTotalRow, costCatCol, [gbtc.fontStyle.bold]);

    gbtu.setValue(packTable, persCostCatInit, costCatCol, RS(SC.GB_stPersonnel));
    gbtu.setIndent(packTable, persCostCatInit, true, Theme.leftIndent);

    gbtu.setValue(packTable, labCostCatInit, costCatCol, RS(SC.GB_stInitVisitLabs));
    gbtu.setIndent(packTable, labCostCatInit, true, Theme.leftIndent);

    gbtu.setValue(packTable, otherRecCostCatInit, costCatCol, RS(SC.GB_stOtherRecurOtherCommEtc));
    gbtu.setIndent(packTable, otherRecCostCatInit, true, Theme.leftIndent);

    gbtu.setValue(packTable, capCostsCostCatInit, costCatCol, RS(SC.GB_stCapCosts));
    gbtu.setIndent(packTable, capCostsCostCatInit, true, Theme.leftIndent);

    gbtu.setValue(packTable, contTotalRow, costCatCol, RS(SC.GB_stContinuationVisit));
    gbtu.setFontStyle(packTable, contTotalRow, costCatCol, [gbtc.fontStyle.bold]);

    gbtu.setValue(packTable, persCostCatCont, costCatCol, RS(SC.GB_stPersonnel));
    gbtu.setIndent(packTable, persCostCatCont, true, Theme.leftIndent);

    gbtu.setValue(packTable, labCostCatCont, costCatCol, RS(SC.GB_stContVisitLabs));
    gbtu.setIndent(packTable, labCostCatCont, true, Theme.leftIndent);

    gbtu.setValue(packTable, otherRecCostCatCont, costCatCol, RS(SC.GB_stOtherRecurOtherCommEtc));
    gbtu.setIndent(packTable, otherRecCostCatCont, true, Theme.leftIndent);

    gbtu.setValue(packTable, capCostsCostCatCont, costCatCol, RS(SC.GB_stCapCosts));
    gbtu.setIndent(packTable, capCostsCostCatCont, true, Theme.leftIndent);

    for (let pp = 1; pp <= defaultPops.length; pp++) {
      let priorPopName;

      if (pseMode) {
        priorPopName = piasu.getPriorPopName(defaultPops, pp);
      } else {
        const priorPopID = piasu.getPriorPopMstID(defaultPops, pp);
        priorPopName = piu.getDefPriorPopNameFromMstID(priorPopID);
      }
      gbtu.setValue(packTable, 0, pp, priorPopName);

      const methodEligMstIDStr = piasu.getPriorPopMethodElig(defaultEligibility, selectedMethodID, pp);
      if (methodEligMstIDStr === pisc.yesCVOMstID) {
        const initVisitCosts = piasu.getInitVisitCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, initTotalRow, pp, initVisitCosts);

        const initPersonnelCosts = piasu.getInitPersonnelCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, persCostCatInit, pp, initPersonnelCosts);

        const initLabCosts = piasu.getInitLabCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, labCostCatInit, pp, initLabCosts);

        const initOtherRecurCosts = piasu.getInitOtherRecurCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, otherRecCostCatInit, pp, initOtherRecurCosts);

        const initCapCosts = piasu.getInitCapCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, capCostsCostCatInit, pp, initCapCosts);

        const contVisitCosts = piasu.getContVisitCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, contTotalRow, pp, contVisitCosts);

        const contPersonnelCosts = piasu.getContPersonnelCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, persCostCatCont, pp, contPersonnelCosts);

        const contLabCosts = piasu.getContLabTestCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, labCostCatCont, pp, contLabCosts);

        const contOtherRecurCosts = piasu.getContOtherRecurCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, otherRecCostCatCont, pp, contOtherRecurCosts);

        const contCapCosts = piasu.getContCapCostsLite(selectedMethodID, defaultCosts, pp);
        gbtu.setValue(packTable, capCostsCostCatCont, pp, contCapCosts);
      } else {
        gbtu.setColBGColor(packTable, pp, Theme.whisperGrayTableColor);
      }
    }

    gbtu.alignNumericCellsRight(packTable);
    gbtu.setRowAlignment(packTable, priorPopRow, gbtc.hAlign.center);
    gbtu.setRDecs(packTable, 2);
    gbtu.setRowHeight(packTable, priorPopRow, 50);

    gbtu.setColWidth(packTable, costCatCol, Theme.itemNameColWidth);
    for (let c = 1; c < numCols; c++) {
      gbtu.setColWidth(packTable, c, Theme.dataColWidthMed);
    }
    gbtu.setWordWrappedCol(packTable, costCatCol, true);

    gbtu.lockPackTable(packTable, true, true);

    return packTable;
  };

  const packTable = getPackTable();

  return (
    <SuperTableShim
      font={Theme.tableFont}
      headerBackgroundColor={Theme.PI_PrimaryColor}
      oddRowBackgroundColor={Theme.PI_BandColor}
      packTable={{ ...packTable, GBRowHeights: repeat(50, packTable.GBRowCount) }}
      types={generateTypes(packTable)}
      onPackTableChanged={() => {}} //this.onTableChange}
      removedMenuNames={pitu.tableHideMenuItems}
      style={{
        tableFont: Theme.tableFont,
        marginTop: Theme.ctrlSpacing,
        padding: 0,
      }}
      width={0}
    />
  );
};

export default PIDefCostsPerVisitRefTable;
